// Import dependencies
import { createRouter, createWebHistory } from 'vue-router'

// Import vue-components
import Home from '@/components/HomePage.vue'
import BlogsList from '@/components/BlogsList.vue'
import BlogsPost from '@/components/BlogsPost.vue'

// Define routes
const routes = [
    { path: '/', component: Home },
    { path: "/blogs", component: BlogsList},
    { path: "/blogs/:slug", component: BlogsPost, props: true}
]

// Define router
const router = createRouter({
    history: createWebHistory(),
    routes
})

// Export router
export default router